import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "components/ui";

const UserHobbiesAndPersonalities = ({ hobAndPrsAry }) => {
  return (
    <div>
      <Card className="min-w-full">
        <CardHeader>
          <CardTitle>Hobbies And Personalities</CardTitle>
        </CardHeader>
        <CardContent className="kt-scrollable-x-auto pb-3 p-0">
          <Table className="align-middle text-sm text-muted-foreground">
            <TableBody>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Hobbies
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {hobAndPrsAry?.hobbies?.length > 0
                    ? hobAndPrsAry.hobbies
                        .map((hobby) => hobby?.hobby?.name)
                        .join(", ")
                    : "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-fit text-secondary-foreground font-normal text-left">
                  Personality
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {hobAndPrsAry?.personalities?.length > 0
                    ? hobAndPrsAry.personalities
                        .map((pers) => pers?.personality?.name)
                        .join(", ")
                    : "N/A"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};

export default UserHobbiesAndPersonalities;
